import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 30,
  height: 29,
}

const Garage = ({ style, color = COLORS.brand.primary }) => (
  <svg xmlns='http://www.w3.org/2000/svg' style={{ ...defaultSize, ...style }} viewBox='0 0 30 29'>
    <g
      stroke={color}
      fill={COLORS.greyscale.white}
      transform='translate(0.5 0.5)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      strokeWidth='1'
    >
      <path
        d='M210.4,438.459V425.294a14.2,14.2,0,1,0-28.4,0v13.165'
        transform='translate(-182 -410.979)'
      />
      <path
        d='M188.179,424.321h-2.643a.569.569,0,0,0-.407.166.578.578,0,0,0-.172.4v.7c0,.6.726.6,1.361.7a41.228,41.228,0,0,0-.677,4.623v5.186a1.027,1.027,0,0,0,1.032,1.021h1.575a1.027,1.027,0,0,0,.728-.3,1.025,1.025,0,0,0,.3-.724v-1.461h13.542v1.461a1.027,1.027,0,0,0,1.03,1.021h1.577a1.027,1.027,0,0,0,1.03-1.021v-5.186a41.017,41.017,0,0,0-.682-4.624c.63-.107,1.346-.087,1.346-.7v-.7a.575.575,0,0,0-.577-.571h-2.622'
        transform='translate(-181.842 -410.267)'
      />
      <path
        d='M203.763,424.387c0,1.13-1.306,1.882-2.538,1.882H190.554c-1.231,0-2.538-.754-2.538-1.882l1.018-3.611a2.263,2.263,0,0,1,2.232-1.94h9.247a2.247,2.247,0,0,1,2.232,1.94Z'
        transform='translate(-181.679 -410.56)'
      />
      <path d='M193.137,431.773h4.939' transform='translate(-181.405 -409.869)' />
      <path d='M193.137,429.42h4.939' transform='translate(-181.405 -409.994)' />
      <path
        d='M203.425,430.663a1.412,1.412,0,0,1-.418.993,1.41,1.41,0,0,1-1,.407,1.416,1.416,0,0,1-.54-.1,1.4,1.4,0,0,1-.458-2.288,1.436,1.436,0,0,1,1.536-.3,1.409,1.409,0,0,1,.877,1.3Z'
        transform='translate(-181.007 -410.003)'
      />
      <path
        d='M190.529,430.663a1.42,1.42,0,0,1-1.954,1.3,1.4,1.4,0,0,1-.767-.757,1.394,1.394,0,0,1,.308-1.531,1.409,1.409,0,0,1,1-.407,1.4,1.4,0,0,1,.54.1,1.409,1.409,0,0,1,.876,1.3Z'
        transform='translate(-181.696 -410.003)'
      />
      <path d='M194.283,420.632h2.548' transform='translate(-181.344 -410.464)' />
      <path d='M206.426,434.125H185.607' transform='translate(-181.807 -409.743)' />
    </g>
  </svg>
)

export default Garage
